import { __assign, __read } from "tslib";
import React, { useRef, useEffect, useState } from 'react';
import { RefText } from '@keen.io/ui-core';
import { motion, AnimatePresence } from 'framer-motion';
import { useTooltip } from '@keen.io/react-hooks';
import { Wrapper, LegendWrapper, TitleWrapper } from './bubble-legend.styles';
import { Tooltip } from '@keen.io/ui-core';
import { Circles } from './bubble-circles.component';
import { Labels } from './bubble-labels.component';
import { TooltipContent } from './tooltip-conent.component';
import { theme as defaultTheme } from '../../../theme';
import { isTruncated } from './bubble-legend.utils';
import { TOOLTIP_MOTION } from '../../../constants';
export var BubbleLegend = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b, typography = _a.typography, domain = _a.domain, title = _a.title, _c = _a.minRadius, minRadius = _c === void 0 ? 5 : _c, _d = _a.maxRadius, maxRadius = _d === void 0 ? 40 : _d;
    var tooltipSettings = theme.tooltip;
    var fontSize = typography.fontSize;
    var titleRef = useRef(null);
    var wrapperRef = useRef(null);
    var _e = __read(useState(false), 2), truncate = _e[0], setTruncate = _e[1];
    useEffect(function () {
        if (titleRef.current) {
            setTruncate(isTruncated(titleRef.current));
        }
    }, [title]);
    var _f = useTooltip(wrapperRef), tooltipVisible = _f.tooltipVisible, tooltipPosition = _f.tooltipPosition, updateTooltipPosition = _f.updateTooltipPosition, hideTooltip = _f.hideTooltip;
    return (React.createElement(Wrapper, { "data-testid": "bubble-legend" },
        React.createElement(AnimatePresence, null, tooltipVisible && truncate && (React.createElement(motion.div, __assign({}, TOOLTIP_MOTION, { initial: { opacity: 0, x: tooltipPosition.x, y: tooltipPosition.y }, animate: {
                x: tooltipPosition.x,
                y: tooltipPosition.y,
                opacity: 1,
            }, style: {
                position: 'absolute',
                pointerEvents: 'none',
                top: title.typography.fontSize,
                left: 0,
            } }),
            React.createElement(Tooltip, { mode: tooltipSettings.mode, hasArrow: false },
                React.createElement(TooltipContent, { typography: tooltipSettings.labels.typography }, title === null || title === void 0 ? void 0 : title.value))))),
        React.createElement(LegendWrapper, null,
            React.createElement(TitleWrapper, { ref: wrapperRef, onMouseEnter: function (e) {
                    if (truncate) {
                        updateTooltipPosition(e);
                    }
                }, onMouseMove: function (e) {
                    if (truncate) {
                        updateTooltipPosition(e);
                    }
                }, onMouseLeave: function () {
                    hideTooltip();
                } }, (title === null || title === void 0 ? void 0 : title.value) && (React.createElement(RefText, __assign({ truncate: true }, title === null || title === void 0 ? void 0 : title.typography, { ref: titleRef }), title.value))),
            React.createElement("svg", { viewBox: "0 0 80 " + (80 + fontSize) },
                React.createElement(Circles, { domain: domain, offsetTop: fontSize }),
                React.createElement(Labels, { domain: domain, typography: typography, minRadius: minRadius, maxRadius: maxRadius })))));
};
export default BubbleLegend;
